/* src/app/modules/investment/investment-tabs.component.css */
/*# sourceMappingURL=investment-tabs.component.css.map */
